import { isMoEmbedded } from "./embed";

// Anchor attributes (with a leading space) for a link rendered inside a Mo message.
//
// Normal admin: an in-place link disables Turbo so it does a full-page navigation in the current
// tab (`data-turbo="false"`); every other link opens a new tab. In the Mo embed (Salespath iframe)
// EVERY link opens a new tab — an in-place admin navigation would otherwise try to load the whole
// admin inside the chat panel. Callers decide what counts as in-place (see render_message_markdown and
// resource_link_renderer); this helper owns the resulting attribute policy.
export default function linkAttributes({ inPlace }) {
  if (inPlace && !isMoEmbedded()) return ' data-turbo="false"';
  return ' target="_blank" rel="noopener noreferrer"';
}
